import React from 'react';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import { withRouter } from 'react-router';
import { removeNotification, changePoints, updateNotification } from '../../actions/basket';
import './styles.css';

class Notifications extends React.Component {
  constructor(props) {
    super(props);
    this.state = { show: false };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.basket && nextProps.basket.notifications && nextProps.basket.notifications.length > 0) {
      this.setState({ show: true });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    // if (nextProps.basket && nextProps.basket.notifications && !nextProps.basket.notifications.length > 0) {
    //   return false;
    // }
    return true;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.basket && prevProps.basket.notifications && prevProps.basket.notifications.length > 0) {
    }
  }

  close = () => {
    this.setState({ show: false });
    this.props.removeNotification();
  };

  yes = () => {
    this.props.updateNotification(this.props.basket.data.id, this.props.basket.notifications[0].validation_field, true);
    this.close();
  };

  no = () => {
    this.props.updateNotification(
      this.props.basket.data.id,
      this.props.basket.notifications[0].validation_field,
      false
    );
    this.close();
  };

  render() {
    const { basket } = this.props;
    if (
      !basket.notifications[0] ||
      (basket.notifications &&
        (basket.notifications[0].type !== 'pop-up' && basket.notifications[0].type !== 'response'))
    )
      return null;

    return (
      <div className="notifications">
        <Modal show={this.state.show} onHide={this.close} container={this} aria-labelledby="contained-modal-title">
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title">
              {basket && basket.notifications && basket.notifications[0].message.title}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              dangerouslySetInnerHTML={{
                __html:
                  basket && basket.notifications && basket.notifications[0] && basket.notifications[0].message.content
              }}
            />
            {basket && basket.notifications && basket.notifications[0].message.buttonText ? (
              <Button
                bsStyle="primary"
                className="success-buttons"
                onClick={basket.notifications[0].type === 'response' ? this.yes : this.close}
              >
                {basket && basket.notifications && basket.notifications[0].message.buttonText}
              </Button>
            ) : null}
            {basket && basket.notifications && basket.notifications[0].message.buttonText2 ? (
              <Button
                bsStyle="primary"
                className="success-buttons"
                onClick={basket.notifications[0].type === 'response' ? this.no : this.close}
              >
                {basket && basket.notifications && basket.notifications[0].message.buttonText2}
              </Button>
            ) : null}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.close}>Close</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default withRouter(
  connect(
    state => ({
      user: state.user,
      basket: state.basket
    }),
    { removeNotification, changePoints, updateNotification }
  )(Notifications)
);



// WEBPACK FOOTER //
// ./src/components/Notifications/index.js